export default __webpack_public_path__ + "static/media/AT.cf32e95f.ico";